<script lang="ts" setup>
import { z } from 'zod'

const { createEvent } = useAnalytics()
const { createToast } = useToasts()
const { t } = useI18n()
const teamsStore = useTeamsStore()

const creating = ref(false)
const form = reactive({ name: '' })

const validation = z.object({
  name: z.string()
    .min(1, { message: t('validation.required') })
    .max(255, { message: t('validation.max', { length: 255 }) }),
})

async function onCreateWebhook() {
  if (!creating.value) {
    creating.value = true

    try {
      await teamsStore.createTeamWebhook({ name: form.name })

      createToast({ message: 'teamWebhookCreated' })
      createEvent({ name: '[Settings] Create Team Webhook' })

      form.name = ''
    }
    catch (error) {
      console.error(error)
    }

    creating.value = false
  }
}
</script>

<template>
  <UForm
    class="flex items-start gap-2"
    :schema="validation"
    :state="form"
    :validate-on="['submit']"
    @submit="onCreateWebhook"
  >
    <UFormGroup
      class="w-full"
      name="name"
    >
      <UInput
        v-model="form.name"
        autocomplete="off"
        :icon="getIcon('webhook')"
        :placeholder="t('enterName')"
        size="md"
      />
    </UFormGroup>

    <UButton
      :icon="getIcon('check')"
      :label="t('createWebhook')"
      :loading="creating"
      size="md"
      type="submit"
      :ui="{ icon: { base: 'text-green-600 dark:text-green-400' } }"
    />
  </UForm>
</template>

<i18n lang="json">
{
  "en": {
    "createWebhook": "Create webhook",
    "enterName": "Enter a name"
  },
  "es": {
    "createWebhook": "Crear webhook",
    "enterName": "Introduce un nombre"
  },
  "fr": {
    "createWebhook": "Créer un webhook",
    "enterName": "Entrez un nom"
  }
}
</i18n>
